<template>
    <div>
        <news-list-filter
        :language-filter.sync="languageFilter"
        :statusFilter.sync="statusFilter"
        :language-options="languageOptions"
        :status-options="statusOptions"
     
        v-if="false"
        />
        <b-card no-body class="mb-0">

        <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="addNews"
                :to="{ name: 'news-create'}"
              >
                <span class="text-nowrap">Add News</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

        <b-table
        ref="refNewsListTable"
        class="position-relative"
        :items="fetchNews"
        responsive
        stacked="md"
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        >
        <!-- Column : News Picture -->
        <template #cell(image_path)="data">
            <b-img
              v-if="data.item.image_path"
              width="150"
              height="150"
              :src="data.item.image_path"
             />
        </template>

        <!-- Column: is_active -->
        <template #cell(is_active)="data">
            <feather-icon 
            v-if="data.item.is_active"
            icon="CheckIcon"
            size="18"
            class="mr-50 text-success"
            />
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
          <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item  :to="{ name: 'news-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item  @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>

        </template>
   
        </b-table>
        <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalNews"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    </div>

</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref } from "@vue/composition-api";
import newsStoreModule from "../newsStoreModule";
import useNewsList from "./useNewsList";
import NewsListFilter from "./NewsListFilter.vue";

export default {
  
  components: {
    NewsListFilter,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BImg,
  },
  methods:{
      confirmDelete(id){
        this.$swal({
        title: '確認刪除?',
        text: 'Your action is final and you will not be able to retrieve the news.',
        showCancelButton: true,
        confirmButtonText: '刪除',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(result => {
        if (result.value) {
          this.$store.dispatch("news/deleteNews", {'id': id})
          .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })
              this.refetchData()
          }).catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })

          })
        }
      })
      },
      addNews(){
          this.isAddNewNewsSidebarActive = true;
      },
  },
  setup() {
    const APP_CLIENT_STORE_MODULE_NAME = "news";
    const isAddNewNewsSidebarActive = ref(false);

    
    if (!store.hasModule(APP_CLIENT_STORE_MODULE_NAME))
      store.registerModule(APP_CLIENT_STORE_MODULE_NAME, newsStoreModule);

    // Filter
    const statusOptions = [
      {label: 'Active', value: 1},
      {label: 'Inactive', value: 0},
      {label: 'All', value: -1}
    ];

    const languageOptions = ref([])
    store.dispatch(APP_CLIENT_STORE_MODULE_NAME+"/fetchLanguages")
    .then((response) => {
        languageOptions.value = response.data.languages
        //console.log(languageOptions.value)
    }).catch((error) => {
        console.log('Error in fetching languages error', error)
    })

    const {
      fetchNews,
      tableColumns,
      perPage,
      currentPage,
      totalNews,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
      refNewsListTable,
      ability,
      languageFilter,
      statusFilter,
      
    } = useNewsList();

    return {
      isAddNewNewsSidebarActive,
      fetchNews,
      tableColumns,
      perPage,
      currentPage,
      totalNews,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
      refNewsListTable,
      ability,
      languageFilter,
      statusFilter,
      languageOptions,
      statusOptions,
     
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.badge {
    display: block;
    margin:5px;
    max-width:200px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
